// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"a867bdd7c0--wrapper--YQcqD","desktop":"a867bdd7c0--desktop--NrsWX","message":"a867bdd7c0--message--pN82c","field":"a867bdd7c0--field--MJens"};